function Loader(props) {

    return (
        <div className="loader-wrap">
            <span className={typeof props.mtop != "undefined" && props.mtop ? "loader mtop-big" : "loader"}></span>
        </div>
    )
}

export default Loader